import {getToken} from "./authService";
import {API_BASE_URL} from "./constants";

export const getCompanyResourceUrl = (resourceId) =>
    API_BASE_URL + '/resource/company/video/' + resourceId + '?token=' + getToken();


// WEBPACK FOOTER //
// ./src/helpers/resourceService.js